import { useLens } from "@hookform/lenses";
import type {
  TransferSizesFormControl,
  transferArtworkMachine
} from "@design-lab/entities/transfers-lab/model/transfer-artwork.machine";
import type { ActorRefFrom } from "xstate";
import { TransfersForm } from "./form/TransfersForm";

interface TransfersFormWrapperProps {
  artworkId: string;
  sizesFormControl: TransferSizesFormControl;
  onAddTransferType: () => void;
  enhancementTier: string;
  artworkActor?: ActorRefFrom<typeof transferArtworkMachine>;
}

/**
 * Wrapper component that safely creates lens and renders TransfersForm
 * This component is only rendered when we have a valid sizesFormControl
 */
export function TransfersFormWrapper({
  artworkId,
  sizesFormControl,
  onAddTransferType,
  enhancementTier,
  artworkActor
}: TransfersFormWrapperProps) {
  const rootLens = useLens(sizesFormControl);

  return (
    <TransfersForm
      artworkId={artworkId}
      artworkLens={rootLens.focus(`artworks.${artworkId}`) as any}
      onAddTransferType={onAddTransferType}
      enhancementTier={enhancementTier}
      {...(artworkActor && { artworkActor })}
    />
  );
}
